import React from 'react';

const BS_InterviewPrep = () => {
    return (
        <div>
            <h1>BS_InterviewPrep Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_InterviewPrep;
